var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('PropertyLabel',{attrs:{"name":_vm.name}},[[_c('br'),_c('span',{staticClass:"has-text-black has-text-weight-medium"},[_vm._v(_vm._s(_vm._f("tryToLocaleDateTime")(_vm._f("emptyValueToText")(_vm.value))))])]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }